import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type RowTextProps = {
  type: 'neutral' | 'positive' | 'negative'
  small?: boolean
}

const colorByType = (type: RowTextProps['type']) => {
  switch (type) {
    case 'neutral':
      return theme.colors.neutral.high
    case 'positive':
      return theme.colors.alert.success.dark
    case 'negative':
      return theme.colors.alert.warning.dark
    default:
      return theme.colors.neutral.high
  }
}
export const RowText = styled.span<RowTextProps>`
  font-weight: ${({ type }) =>
    type === 'neutral' ? theme.typography.weight.xsm : theme.typography.weight.lg};
  color: ${({ type }) => colorByType(type)};
  font-size: ${({ small }) => (small ? theme.typography.sizes['3xs'] : theme.typography.sizes.xs)};

  #colorText {
    padding-left: ${theme.spacing.xs};
  }
`
export const RowIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  span {
    display: flex;
    align-items: center;
  }
`

export const ActionsCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  height: ${theme.spacing['2xm']};
  width: ${theme.spacing['2xm']};
  border-radius: ${theme.shapes.borderRadius.sm};
`

export const ApproveButton = styled(ActionButton)`
  background: ${theme.colors.alert.success.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const RejectButton = styled(ActionButton)`
  background: ${theme.colors.alert.danger.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${theme.spacing.sm};
  padding-top: ${theme.spacing.sm};
  border-top: 1px solid ${theme.colors.neutral.lighthover};
`

export const FooterRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-top: ${theme.spacing.md};
`

export const ColContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
`

export const FooterActions = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  align-items: center;
`
